"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseShardRowFingerprintsMissingError = exports.DatabaseShardDirectoryPartsMissingError = exports.DatabaseShardDirectoryFormatError = exports.UnsupportedDatabaseStorageVersionError = void 0;
/**
 * Named errors of the stored database format. There is one storage version;
 * a value in any other version is never read or converted.
 */
class UnsupportedDatabaseStorageVersionError extends Error {
    constructor(subject, storageVersion, currentStorageVersion) {
        super(`${subject} uses unsupported storage version ${String(storageVersion)}; current version is ${currentStorageVersion}`);
        this.storageVersion = storageVersion;
        this.currentStorageVersion = currentStorageVersion;
        this.name = 'UnsupportedDatabaseStorageVersionError';
    }
}
exports.UnsupportedDatabaseStorageVersionError = UnsupportedDatabaseStorageVersionError;
/** A stored shard directory value has the wrong shape for its reader. */
class DatabaseShardDirectoryFormatError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'DatabaseShardDirectoryFormatError';
    }
}
exports.DatabaseShardDirectoryFormatError = DatabaseShardDirectoryFormatError;
/** A reader needs directory parts that are not loaded or not in step yet. */
class DatabaseShardDirectoryPartsMissingError extends Error {
    constructor(databaseId, partDocIds) {
        super(`Database shard directory parts are not loaded (${partDocIds.length} missing)`);
        this.databaseId = databaseId;
        this.partDocIds = partDocIds;
        this.name = 'DatabaseShardDirectoryPartsMissingError';
    }
}
exports.DatabaseShardDirectoryPartsMissingError = DatabaseShardDirectoryPartsMissingError;
/**
 * A shard entry holding rows has no row fingerprints. Every writer records
 * the fingerprint of a row with the row, so the entry is corrupt.
 */
class DatabaseShardRowFingerprintsMissingError extends Error {
    constructor(shardId) {
        super(`Database row shard ${shardId} holds rows without row fingerprints`);
        this.shardId = shardId;
        this.name = 'DatabaseShardRowFingerprintsMissingError';
    }
}
exports.DatabaseShardRowFingerprintsMissingError = DatabaseShardRowFingerprintsMissingError;
